// src/store/reducers/index.ts
import { combineReducers } from 'redux';
import eventData from './Event/eventReducer';
import participantData from './Event/participantReducer';
import scheduleReducer from './Event/eventScheduler';
import homePage from './HomePage';


export default combineReducers({
    eventData,
    participantData,
    homePage,
    schedule: scheduleReducer
});


